export enum Colors {
    RED = 'red',
    GREEN = 'green',
    BLUE = 'blue',
    YELLOW = 'yellow',
    ORANGE = 'orange',
    PURPLE = 'purple',
    PINK = 'pink',
    BROWN = 'brown',
    AMBER = 'amber',
    LIME = 'lime',
    INDIGO = 'indigo',
    TEAL = 'teal',
    CYAN = 'cyan',
    EMERALD = 'emerald',
    SKY = 'sky',
    VIOLET = 'violet',
    FUCHSIA = 'fuchsia',
    ROSE = 'rose',
}
